<template>
  <div class="container-invite-history" :style="cssVars()">
    <div class="custom-nav-block" :style="`paddingTop:${topBarHeight}px`">
      <van-nav-bar class="van-bar" title="" @click-left="goPrevious">
        <template #left>
          <img class="left-nav" src="@/assets/packageAssets/common/arrow01.webp" alt="" />
          <!-- Income Details -->
          <span class="tit-left">{{ $t('lang.InviteHistory.k002') }}</span>
        </template>
      </van-nav-bar>
    </div>

    <div class="main" @scroll.passive="handleListScroll">
      <div class="filter-box">
        <div class="filter-item" @click="handleTimePop">
          <span>{{ handleMoment(chooseTime, 'YYYY-MM') }}</span>
          <img class="filter-arrow" src="@/assets/packageAssets/common/arrow06.webp" alt="" />
        </div>
        <div class="filter-item filter-item-type" @click.stop="toggleStatusPop">
          <span>{{ activeStatusLabel }}</span>
          <img class="filter-arrow" :class="{ open: showStatusPopover }" src="@/assets/packageAssets/common/arrow06.webp" alt="" />
          <div v-if="showStatusPopover" class="status-dropdown">
            <div
              v-for="item in statusOptions"
              :key="item.id"
              class="status-option"
              :class="{ active: activeStatusLabel === item.text }"
              @click="selectStatus(item.text, item)"
            >
              {{ item.text }}
            </div>
          </div>
        </div>
      </div>

      <div class="list">
        <div class="list-item" v-for="item in incomeList" :key="item.id">
          <div class="item-info">
            <!-- statusOptionsDetail -->
            <div class="item-title">
              {{ getItemTitleText(item) }}
              <span v-if="item.billCategoryType == 14 && item.remark">{{ item.remark }}%</span>
            </div>
            <div v-if="showItemSub(item)" class="item-sub">{{ getItemSub(item) }}</div>
          </div>
          <div class="item-side">
            <div class="item-beans">
              <span :class="{ 'is-negative': isNegativeAmount(item.changeAmount) }">{{ formatAmount(item.changeAmount) }}</span>
              <img :src="getMatchImg('beans')" alt="" />
            </div>
            <div class="item-time">{{ handleMoment(item.createTime, 'DD MMM HH:mm:ss') }}</div>
          </div>
        </div>
      </div>
      <div v-if="listLoading" class="is-loading">
        <van-loading size="24px" />
      </div>
    </div>

    <CTime :showPop="showDatePop" @handleCurrentDate="handleCurrentDate" />
  </div>
</template>

<script>
import { apiFetchInviteHistory } from '@/api/imee'
import { getBaseFeature } from '@/assets/style/variable'

import CTime from '@/components/CTime'

const LIST_PAGE_SIZE = 15

export default {
  components: { CTime },
  props: {},
  data() {
    const query = this.$route.query
    return {
      topBarHeight: query.statusBarHeight || 38,
      // 弹出层
      showDatePop: false,
      showStatusPopover: false,
      // api
      chooseTime: new Date(),
      billCategoryType: '',
      walletType: query.walletType || 1,
      listOffset: 0,
      listLimit: LIST_PAGE_SIZE,
      listLoading: false,
      listFinished: false,
      // 列表
      incomeList: [],
      // 状态下拉
      activeStatusLabel: this.$t('lang.BaseModule.k006'),
      statusOptions: [
        {
          id: 'All',
          text: this.$t('lang.BaseModule.k006'),
          includeSubStatus: [
            // All
            { id: '-1', text: this.$t('lang.BaseModule.k006') },
          ],
        },
        {
          id: 'Hostess',
          text: this.$t('lang.BaseModule.k028'),
          includeSubStatus: [
            // Hostess Commission
            { id: '14', text: this.$t('lang.Invite.k038') },
            // Hostess Invite Bonus
            { id: '15', text: this.$t('lang.Invite.k036') },
            // Hostess Event Bonus
            { id: '18', text: this.$t('lang.Invite.k037') },
            // Bonus Deduction
            { id: '19', text: this.$t('lang.InviteHistory.k001') },
          ],
        },
        {
          id: 'Sub-agent',
          text: this.$t('lang.Invite.k057'),
          includeSubStatus: [
            // Sub-agent Commission
            { id: '20', text: this.$t('lang.Invite.k064') },
            // Sub-agent Event Bonus
            { id: '21', text: this.$t('lang.Invite.k041') },
          ],
        },
        {
          id: 'Others',
          text: this.$t('lang.BaseModule.k043'),
          includeSubStatus: [
            // Others
            { id: '17', text: this.$t('lang.BaseModule.k043') },
          ],
        },
      ],
    }
  },
  computed: {
    billCategoryTextMap() {
      const map = {}
      this.statusOptions.forEach((option) => {
        ;(option.includeSubStatus || []).forEach((sub) => {
          map[sub.id] = sub.text
          map[Number(sub.id)] = sub.text
        })
      })
      return map
    },
  },
  created() {
    this.loadHistoryList()
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    cssVars() {
      return { ...getBaseFeature() }
    },
    resetListState() {
      this.incomeList = []
      this.listOffset = 0
      this.listFinished = false
      this.listLoading = false
    },
    handleListScroll(event) {
      const el = event.target
      if (this.listLoading || this.listFinished) return
      if (el.scrollTop + el.clientHeight >= el.scrollHeight - 80) {
        this.loadHistoryList()
      }
    },
    loadHistoryList() {
      if (this.listLoading || this.listFinished) return
      this.listLoading = true
      const params = {
        walletType: this.walletType,
        billCategoryType: this.billCategoryType || '',
        limit: this.listLimit,
        offset: this.listOffset,
        ...this.getMonthStartAndEnd(this.chooseTime),
      }
      apiFetchInviteHistory(params)
        .then((res) => {
          const items = res || []
          this.incomeList = this.incomeList.concat(items)
          this.listOffset = this.incomeList.length
          this.listFinished = items.length < this.listLimit
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleTimePop() {
      this.showStatusPopover = false
      this.showDatePop = true
    },
    handleCurrentDate(val) {
      this.chooseTime = val
      this.resetListState()
      this.loadHistoryList()
    },
    closePop() {
      this.showDatePop = false
    },
    toggleStatusPop() {
      this.showStatusPopover = !this.showStatusPopover
    },
    handleOutsideClick() {
      this.showStatusPopover = false
    },
    selectStatus(val, item) {
      this.activeStatusLabel = val

      this.billCategoryType = item.includeSubStatus
        .map((sub) => sub.id)
        .filter((id) => id !== '-1')
        .join(',')

      this.showStatusPopover = false

      this.resetListState()
      this.loadHistoryList()
    },
    getItemTitleText(item) {
      const type = item.billCategoryType
      return this.billCategoryTextMap[type] ?? this.billCategoryTextMap[String(type)] ?? this.$t('lang.BaseModule.k043')
    },
    showItemSub(item) {
      return (item.billCategoryType == 15 || item.billCategoryType == 18 || item.billCategoryType == 19) && item.fromName
    },
    getItemSub(item) {
      return item.fromName || ''
    },
    isNegativeAmount(amount) {
      const num = Number(amount)
      return !Number.isNaN(num) && num < 0
    },
    formatAmount(amount) {
      const num = Number(amount)
      if (Number.isNaN(num)) return amount
      if (num > 0) return `+${amount}`
      return String(amount)
    },
  },
}
</script>

<style lang="scss" scoped>
.container-invite-history {
  width: 100%;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  background: #f6f6f5;

  .custom-nav-block {
    flex-shrink: 0;
    background: #ffffff;

    ::v-deep .van-nav-bar__left {
      .tit-left {
        color: #333333;
        font-size: var(--fs-20);
        font-weight: var(--fw-500);
        line-height: var(--lh-title-24);
      }
    }

    .left-nav {
      width: 20px;
      height: 20px;
      margin-right: 4px;
      object-fit: contain;
    }
  }

  .main {
    flex: 1;
    overflow-y: auto;
    -webkit-overflow-scrolling: touch;

    .filter-box {
      position: sticky;
      top: 0;
      z-index: 10;
      display: flex;
      align-items: center;
      padding: 4px 0;
      min-height: 52px;
      box-sizing: border-box;
      background: #ffffff;
      border-bottom: 1px solid #eeeeee;

      .filter-item {
        flex: 1;
        min-width: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 4px;
        padding: 12px 0;
        font-family: var(--string-font);
        font-size: var(--fs-16);
        font-weight: var(--fw-400);
        line-height: var(--lh-title-20);
        color: #333333;
        cursor: pointer;

        .filter-arrow {
          width: 16px;
          height: 16px;
          flex-shrink: 0;
          transition: transform 0.2s;

          &.open {
            transform: rotate(180deg);
          }
        }
      }

      .filter-item-type {
        position: relative;
      }

      .status-dropdown {
        position: absolute;
        top: calc(100% + 4px);
        left: 50%;
        transform: translateX(-50%);
        min-width: 140px;
        max-height: 280px;
        overflow-y: auto;
        background: #ffffff;
        border-radius: 8px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
        z-index: 10;

        .status-option {
          padding: 10px 16px;
          font-family: var(--string-font);
          font-size: var(--fs-14);
          font-weight: var(--fw-400);
          line-height: var(--lh-title-20);
          color: #666666;
          white-space: nowrap;
          text-align: center;

          &.active {
            color: #333333;
            font-weight: var(--fw-500);
          }
        }
      }
    }

    .list {
      padding: 8px 16px 24px;

      .list-item {
        display: flex;
        align-items: center;
        gap: 12px;
        padding: 8px 0;
        min-height: 59px;
        box-sizing: border-box;

        .item-info {
          flex: 1;
          min-width: 0;
          display: flex;
          flex-direction: column;
          gap: 2px;
          justify-content: center;
          min-height: 43px;

          .item-title {
            font-family: var(--string-font);
            font-size: var(--fs-14);
            font-weight: var(--fw-400);
            line-height: var(--lh-title-20);
            color: #333333;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }

          .item-sub {
            font-family: var(--string-font);
            font-size: 12px;
            font-weight: var(--fw-400);
            line-height: 16px;
            color: #b2b2b2;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
        }

        .item-side {
          flex-shrink: 0;
          display: flex;
          flex-direction: column;
          align-items: flex-end;
          gap: 2px;
          justify-content: center;
          min-height: 43px;

          .item-beans {
            display: flex;
            align-items: center;
            gap: 2px;
            font-family: var(--string-font);
            font-size: var(--fs-16);
            font-weight: var(--fw-400);
            line-height: 22px;
            color: #333333;

            span.is-negative {
              color: #ff4265;
            }

            img {
              width: 16px;
              height: 16px;
            }
          }

          .item-time {
            font-family: var(--string-font);
            font-size: 12px;
            font-weight: var(--fw-400);
            line-height: 16px;
            color: #b2b2b2;
            white-space: nowrap;
          }
        }
      }

      .invite-history-empty {
        margin-top: 150px;
      }
    }

    .is-loading {
      display: flex;
      justify-content: center;
      padding: 16px 0 24px;
    }

    .no-more {
      padding: 16px 0 24px;
      text-align: center;
    }
  }
}

html[lang='ar'],
html[lang='fa'],
html[lang='he'] {
  .container-invite-history {
    .main {
      .filter-box {
        .status-dropdown {
          left: auto;
          right: 50%;
          transform: translateX(50%);
        }
      }
    }
  }
}
</style>
